export const MY_VIDEO_WINDOW_SHOW = 'MY_VIDEO_WINDOW_SHOW';
export const MY_VIDEO_WINDOW_HIDE = 'MY_VIDEO_WINDOW_HIDE';
export const MY_VIDEO_WINDOW_TOGGLE = 'MY_VIDEO_WINDOW_TOGGLE';
export const MY_VIDEO_WINDOW_PAUSE = 'MY_VIDEO_WINDOW_PAUSE';
export const MY_VIDEO_WINDOW_UNPAUSE = 'MY_VIDEO_WINDOW_UNPAUSE';
export const MY_VIDEO_WINDOW_RECORD_START = 'MY_VIDEO_WINDOW_RECORD_START';
export const MY_VIDEO_WINDOW_RECORD_STOP = 'MY_VIDEO_WINDOW_RECORD_STOP';
export const MY_VIDEO_WINDOW_RECORD_ERROR = 'MY_VIDEO_WINDOW_RECORD_ERROR';
export const MY_VIDEO_WINDOW_ENABLE_SOUND = 'MY_VIDEO_WINDOW_ENABLE_SOUND';
export const MY_VIDEO_WINDOW_DISABLE_SOUND = 'MY_VIDEO_WINDOW_DISABLE_SOUND';
export const MY_VIDEO_WINDOW_FULLSCREEN = 'MY_VIDEO_WINDOW_FULLSCREEN';
export const MY_VIDEO_WINDOW_COLLAPSE = 'MY_VIDEO_WINDOW_COLLAPSE';
export const MY_VIDEO_WINDOW_CLEAR_MESSAGE = 'MY_VIDEO_WINDOW_CLEAR_MESSAGE';



// WEBPACK FOOTER //
// ./src/constants/myVideoWindow.js